@let notificationItem = notification();

@if (statusVisuals(); as statusVisuals) {
  <div
    [class]="statusVisuals.badgeClass"
    class="flex size-6 shrink-0 items-center justify-center rounded-full"
  >
    <i
      [class]="statusVisuals.iconClass"
      class="text-base/4"
    ></i>
  </div>
}

<div class="flex flex-1 min-w-0 flex-col">
  <ng-content select="[notificationTitle]" />

  @if (notificationItem.hasContext) {
    <flx-notification-context
      [notification]="notificationItem"
      class="mt-1"
    />
  }

  <flx-notification-summary [summary]="notificationItem.summary" />

  @if (notificationItem.body) {
    <p
      class="mt-1 text-xs/[18px] text-neutral-900"
      data-testid="notification-body"
    >
      {{ notificationItem.body }}
    </p>
  }

  @if (notificationItem.action; as action) {
    <button
      (click)="runAction()"
      class="flx-ds ternary small mt-2 self-start"
      data-testid="notification-action-button"
      flxButton
      icon="left"
      type="button"
    >
      <i
        [class]="action.iconClass"
        flxIcon
      ></i>
      {{ action.label }}
    </button>
  }
</div>
